const salads = [
    {
        item: "Cobb Salad",
        ingredients: "chicken breast, bacon, tomato, avocado, provolone cheese"
    },
    {
        item: "Chicken Caesar Salad",
        ingredients: "chicken breast, lettuce, croutons, parmesan cheese",
    },
    {
        item: "Santa Fe Chicken Salad",
        ingredients: "chicken breast, chipotle ranch, lettuce, tomato, onions, corn, tortilla strips, cheddar cheese",
    },
    {
        item: "Greek Salad",
        ingredients: "lettuce, artichokes, olives, feta cheese, onions, tomatoes, cucumbers",
    }, 
    {
        item: "Oriental Chicken Salad",
        ingredients: "chicken breast, romaine lettuce, onions, tomato, almonds, mandarins, wonton chips"
    }
]

export default salads